import { createFileRoute } from "@tanstack/react-router";
import SpravatoTriedEverything from "@/pages/SpravatoTriedEverything";
export const Route = createFileRoute("/spravato-tried-everything")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Spravato Tried Everything | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Tried everything for depression? SPRAVATO and TMS offer new options when medications haven’t worked. Learn more in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Spravato Tried Everything | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Tried everything for depression? SPRAVATO and TMS offer new options when medications haven’t worked. Learn more in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-tried-everything",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-tried-everything",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoTriedEverything />;
}
